// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-ee9131e4] .input-class:hover,[data-v-ee9131e4] .input-class:focus {
  background-color: transparent !important;
}
.search-input-enter-active[data-v-ee9131e4] {
  transition: opacity 0.15s ease 0.05s;
}
.search-input-leave-active[data-v-ee9131e4] {
  transition: opacity 0.1s ease;
}
.search-input-enter-from[data-v-ee9131e4],
.search-input-leave-to[data-v-ee9131e4] {
  opacity: 0;
}
[data-v-ee9131e4] #filterSlot {
  flex-wrap: wrap;
}
@media (min-width: 768px) {
[data-v-ee9131e4] #filterSlot {
    flex-wrap: nowrap;
}
}
[data-v-ee9131e4] #filterSlot .p-dropdown.form-control {
  padding: 13px 16px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
